import { render, staticRenderFns } from "./MPesaPaymentPage.vue?vue&type=template&id=67261093&"
import script from "./MPesaPaymentPage.vue?vue&type=script&lang=js&"
export * from "./MPesaPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports